// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2oiTV","title":"ClientInsurance_title__2rnSy","itemText":"ClientInsurance_itemText__3-__T"};